const HeaderSearch = () => {
  const screenWidth = window.innerWidth;
  const body = document.body;
  const searchWrapper = document.querySelector(".header__search-wrapper");
  const opener = document.querySelector(".header__search-opener");
  const tabletOpener = document.querySelector(".header__search-opener-tablet");
  const headerNav = document.querySelector(".header__nav");
  const form = document.querySelector(".header__search-form");
  const input = form.querySelector(".header__search-input");
  const searchResults = document.querySelector(".header__search-results");
  const burgerMenuOpener = document.querySelector(".header__burger-menu-opener");

  if (opener) {
    opener.addEventListener("click", () => {
      if (opener.classList.contains("opened")) {
        input.value = "";
        searchResults.classList.remove("opened");
      }

      if (screenWidth > 1023) {
        headerNav.classList.toggle("d-none");
      }

      opener.classList.toggle("opened");
      searchWrapper.classList.toggle("opened");
      input.focus();
    });
  }

  if (tabletOpener) {
    tabletOpener.addEventListener("click", () => {
      opener.classList.add("opened");
      searchWrapper.classList.add("opened");
      input.focus();
      headerNav.classList.remove("opened");
      burgerMenuOpener.classList.remove("opened");
      body.classList.remove("no-scroll");
    })
  }

  // if (form) {
  //   input.addEventListener('input', () => {
  //     if (input.value.trim().length >= 3) {
  //       searchResults.classList.add('opened');
  //     } else {
  //       searchResults.classList.remove('opened');
  //     }
  //   });
  // }
}

export default HeaderSearch;